import type { RuleHandler } from "../types";

const checkStakeSource: RuleHandler = (context, requirement) => {
  const requiredStakeSource = requirement.userDrivenAttributes?.stakeSource!;

  if (requiredStakeSource !== context.selection.stakeSource) {
    return false;
  }
  return true;
};

export { checkStakeSource };
